import clsx from "clsx";

import { formatNumber } from "helpers/formatNumber";
import { useColorScheme } from "hooks/useColorScheme";
import { IFRCalculationResult } from "models/HaulPay";
import styles from "./style.module.scss";

interface IProps {
  frCalculation?: IFRCalculationResult;
}

export default function CarrierFrStatus({ frCalculation }: Readonly<IProps>) {
  const { currentIsDark } = useColorScheme();

  const {
    contract_type: contractType,
    payment_profile_discount_rate: carrierRate,
    payment_profile_fee: carrierFee,
    payment_profile_payable: carrierPay,
    carrier_total_amount: carrierTotalAmount,
    discount_rate_comfreight: QPRate,
    factoring_fee_split_rate: carrierQPRate,
    carrier_line_haul: carrierLineHaul,
    qp_total_fee: QPTotalFee,
    carrier_qp_fee: carrierQPFee
  } = (frCalculation ?? {
    payment_profile_discount_rate: 0,
    payment_profile_fee: 0,
    payment_profile_payable: 0,
    carrier_total_amount: 0,
    discount_rate_comfreight: 0,
    factoring_fee_split_rate: 100,
    carrier_line_haul: 0,
    qp_total_fee: 0,
    carrier_qp_fee: 0
  }) as IFRCalculationResult;

  return (
    <div
      className={clsx(
        styles.cardBoxWrapper,
        !currentIsDark && "drop-shadow-[0_2px_4.5px_#9E9E9E33]"
      )}>
      <span className={styles.cardTitle}>Carrier</span>
      <ul className={clsx(styles.cardBody, "desktop:!grid desktop:!grid-cols-4 desktop:!gap-x-2")}>
        {contractType?.startsWith("SELF_FINANCE") ? (
          <>
            <li>
              <span className="text-xs desktop:text-sm">Line Haul</span>
              <span className="font-bold text-success">
                {formatNumber(carrierLineHaul / 100, 2)}
              </span>
            </li>
            <li>
              <span className="text-xs desktop:text-sm">{`QP Rate ${QPRate}%`}</span>
              <span className="font-bold text-error">{formatNumber(QPTotalFee / 100, 2)}</span>
            </li>
            <li>
              <span className="text-xs desktop:text-sm">
                {`Carrier QP Fee ${100 - carrierQPRate}%`}
              </span>
              <span className="font-bold text-error">{formatNumber(carrierQPFee / 100, 2)}</span>
            </li>
            <li className="!border-none">
              <span className="text-xs desktop:text-sm mobile:text-time">Carrier Pay</span>
              <span className="font-bold text-success">
                {formatNumber(carrierTotalAmount / 100, 2)}
              </span>
            </li>
          </>
        ) : (
          <>
            <li className="!border-none">
              <span className="text-xs desktop:text-sm">Carrier&apos;s Rate</span>
              <span className="text-error">
                {contractType && contractType !== "NON_FACTORED_BILL_OUT"
                  ? `${carrierRate}%`
                  : "0%"}
              </span>
            </li>
            <li className="!border-none">
              <span className="text-xs desktop:text-sm">Your Carrier&apos;s Fee</span>
              <span className="font-bold text-error">
                {contractType && contractType !== "NON_FACTORED_BILL_OUT"
                  ? formatNumber(carrierFee / 100, 2)
                  : "$0.00"}
              </span>
            </li>
            <li className="!border-none">
              <span className="text-xs desktop:text-sm mobile:text-time">
                Your Carrier&apos;s Pay
              </span>
              <span className="font-bold text-success">
                {contractType && contractType !== "NON_FACTORED_BILL_OUT"
                  ? formatNumber(carrierPay / 100, 2)
                  : "$0.00"}
              </span>
            </li>
          </>
        )}
      </ul>
    </div>
  );
}
